import { useLanguageContext } from "../../../../context/LanguageContext";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import { faPlus, faTrash, faWarning } from "@fortawesome/free-solid-svg-icons";
import Select from "../../../../components/select/main/Select";
import { useAuthContext } from "../../../../context/AuthContext";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import {
  StyledDataTableHeader,
  StyledDataTableWrapper,
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledTableWrapper,
} from "../../../../components/dataTable/main/DataTableStyles";
import { useTheme } from "styled-components";
import { StyledFlexRow } from "../../../../styles/LayoutStyles";

function PaxtonDoorsView({
  availableDoors = [],
  doorLabels = {},
  configData,
  onDoorAdd,
  onDoorChange,
  onDoorDelete,
}) {
  const authContext = useAuthContext();
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledDataTableWrapper>
      <StyledDataTableHeader>
        <StyledHeaderLeft>
          <StyledHeader>{translate("eva.main.entities.doors")}</StyledHeader>
        </StyledHeaderLeft>

        <StyledHeaderRight>
          <IconSelect
            options={availableDoors.map((door) => ({
              value: door.id,
              label: door.name,
            }))}
            icon={() => <FontAwesomeIcon icon={faPlus} />}
            style={{ marginLeft: "auto" }}
            onChange={(value) => onDoorAdd(value)}
            disabled={availableDoors.length <= 0}
          />
        </StyledHeaderRight>
      </StyledDataTableHeader>
      <OverlayLoader groups="paxton_configs_page_fetch">
        <StyledTableWrapper>
          <table>
            <thead>
              <tr>
                <th style={{ width: "50%" }}>
                  {translate("eva.main.validation.attributes.doors.*.door_id")}
                </th>

                <th style={{ width: "50%" }}>
                  {translate(
                    "eva.main.validation.attributes.locks.*.location_id",
                  )}
                </th>

                <th style={{ width: 0 }}></th>
              </tr>
            </thead>

            <tbody>
              {configData?.doors?.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    {translate("eva.main.general.no_results")}
                  </td>
                </tr>
              )}

              {configData?.doors?.map((configDoor) => (
                <tr key={configDoor.door_id}>
                  <td>
                    <StyledFlexRow style={{ alignItems: "center" }}>
                      <span>
                        {doorLabels[configDoor.door_id] ?? "Unknown Door"}
                      </span>

                      {configDoor.door_name !==
                        doorLabels[configDoor.door_id] && (
                        <FontAwesomeIcon
                          icon={faWarning}
                          style={{ color: theme.colors.accent.normal }}
                        />
                      )}
                    </StyledFlexRow>
                  </td>

                  <td>
                    <Select
                      value={configDoor.location_id}
                      options={authContext.auth?.user?.company?.locations?.map(
                        (location) => ({
                          value: location.id,
                          label: location.name,
                        }),
                      )}
                      onChange={(value) =>
                        onDoorChange(configDoor.door_id, "location_id", value)
                      }
                    />
                  </td>

                  <td>
                    <StyledAltIconButton
                      onClick={() => onDoorDelete(configDoor.door_id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </StyledAltIconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </StyledTableWrapper>
      </OverlayLoader>
    </StyledDataTableWrapper>
  );
}

export default PaxtonDoorsView;
